var React = require('react');

function Cart (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cart-1{fill:#414042;}")),React.createElement("title",{"key":1},"Home-Cart"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":2},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("path",{"className":"cart-1","d":"M.6,0a.6.6,0,0,0,0,1.2H2.51l2.07,9.74c.08.37.32.67.62.67h10a.62.62,0,0,0,.61-.6.62.62,0,0,0-.61-.6H5.69l-.25-1.2H16a.63.63,0,0,0,.58-.47l1.4-6A.62.62,0,0,0,17.41,2H3.92L3.59.48A.63.63,0,0,0,3,0ZM4.17,3.2H16.66L15.54,8H5.19Zm3.24,9.21a2,2,0,1,0,2,2,2,2,0,0,0-2-2Zm5.6,0a2,2,0,1,0,2,2,2,2,0,0,0-2-2Zm-5.6,1.2a.8.8,0,1,1-.81.8A.8.8,0,0,1,7.41,13.61Zm5.6,0a.8.8,0,1,1-.8.8A.79.79,0,0,1,13,13.61Z"})))]);
}

Cart.defaultProps = {"viewBox":"0 0 18.01 16.41"};

module.exports = Cart;

Cart.default = Cart;
